import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { isRichTextEmpty } from '../../Reusables/RichText/richTextConfig';
import {
	sanitizeOutreachSignatureHtml,
	signaturePreviewDocument,
} from '../../../utils/sanitizeOutreachSignature';

/** Renders outreach email HTML (incl. table signatures) without clipping or app scrollbars. */
const OutreachEmailHtmlPreview = ({ html, minHeight = 200, maxHeight = 420 }) => {
	const srcDoc = useMemo(() => {
		if (isRichTextEmpty(html)) return '';
		return signaturePreviewDocument(sanitizeOutreachSignatureHtml(html));
	}, [html]);

	if (!srcDoc) return null;

	return (
		<Box
			border='1px solid'
			borderColor='gray.200'
			borderRadius='md'
			bg='white'
			overflow='hidden'>
			<iframe
				title='Email preview'
				srcDoc={srcDoc}
				sandbox=''
				style={{
					display: 'block',
					width: '100%',
					minHeight,
					height: maxHeight,
					border: 0,
					background: '#fff',
				}}
			/>
		</Box>
	);
};

export default OutreachEmailHtmlPreview;
